// import { Spin } from "antd";
// import { useState } from "react";
// import { useDispatch } from "react-redux";
// import { calculator } from "../../../../base/utils";
// import { Note } from "../../../../helbest";
// import { API } from "../../../../request/api";
// import DetailModal from "./DetailModal/DetailModal";
import { useTranslation } from "react-i18next";
import { ReactComponent as AddressLocationIcon } from "../../../../../assets/svg/address-location.svg";
import styles from "./Addresses.module.css";

const Addresses = (props) => {
  const {
    shipping_address,
    billing_address,
    shippingCompanyName,
    billingCompanyName,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.BoxAddresses}>
      <div className={styles.Content}>
        <h5 className={styles.ContentTitle}>
          {t("addresses.shipping_address")}
        </h5>
        <div className={styles.AddressLine}>
          <AddressLocationIcon className={styles.AddressIcon} />
          <span>{shipping_address}</span>
        </div>
        {shippingCompanyName && (
          <div className={styles.AddressLine}>
            <AddressLocationIcon className={styles.AddressIcon} />
            <span>{shippingCompanyName}</span>
          </div>
        )}

        <div className={`${styles.Separator}`} />
        <h5 className={styles.ContentTitle}>
          {t("addresses.billing_address")}
        </h5>
        <div className={styles.AddressLine}>
          <AddressLocationIcon className={styles.AddressIcon} />
          <span>{billing_address}</span>
        </div>
        {billingCompanyName && (
          <div className={styles.AddressLine}>
            <AddressLocationIcon className={styles.AddressIcon} />
            <span>{billingCompanyName}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Addresses;
